// axios
import axios from 'axios'
import { BASE_URL, UPLOAD_URL } from '../config/constants'
import store from '../store'
import router from '../config/router'

axios.defaults.baseURL = BASE_URL
axios.defaults.timeout = 300000

axios.interceptors.request.use((config) => {
  config.headers['accessToken'] = store.state.token
  return config
}, (error) => {
  return Promise.reject(new Error(error.message))
})

axios.interceptors.response.use((response) => {
  let result = response.data
  if (result.code === '2000') {
    return result
  } else if (['14003', '14004'].indexOf(result.code) !== -1) {
    store.commit('clearAuth')
  } else if (['14005', '14006'].indexOf(result.code) !== -1) {
    router.push('/forbidden')
  } else if (['14002'].indexOf(result.code) !== -1) {
    router.push('/notFound')
  } else if (['15000', '15001', '15002'].indexOf(result.code) !== -1) {
    // router.push('/serverError')

    // $Message.error('获取订单列表失败: ' + err.message)
  }
  return Promise.reject(result.msg)
}, (error) => {
  return Promise.reject(error.message)
})

export default {
  axios,
  BASE_URL,
  UPLOAD_URL,
  post: (url = '') => {
    return (data = {}, config = {}) => {
      return axios.post(url, data, config)
    }
  },
  get: (url = '') => {
    return (params = {}, config = {}) => {
      return axios.get(url, { params, ...config })
    }
  },
  redirectToLogin: () => {
    router.push('/login').catch(() => {})
  },
  redirectToHomepage: () => {
    router.push('/').catch(() => {})
  }
}
